import React, {Suspense} from 'react'
import { Route, Switch } from 'react-router-dom'
import { CookiesProvider, withCookies } from 'react-cookie';
import yn from 'yn'
import LoginPage from './LoginPage'
import ChangePasswordPage from './ChangePassword'
import ForgotPasswordPage from './ForgotPasswordPage'
import RecoveryAccessPage from './Onboarding'
import ConfirmationAccountPage from './ConfirmationAccount'
import Loading from './Loading';

const SignUpUraPage = React.lazy(() => import('./SignUpUra'))
const SignUpPage = React.lazy(() => import('./SignUp'))
const CreateUraPasswordPage= React.lazy(() => import('./CreateUraPassword'))

const App = () => (
  <CookiesProvider>
    <Switch>
      <Suspense fallback={<Loading />}>
      <Route exact path='/login' component={LoginPage} />
      <Route exact path='/changePassword' component={ChangePasswordPage} />
      <Route exact path='/forgot-password' component={ForgotPasswordPage} />
      <Route exact path='/recovery' component={RecoveryAccessPage} />
      {
        yn(process.env.RAZZLE_ALLOW_SIGN_UP_URA)
          ? <Route exact path='/signup' component={SignUpUraPage} />
          : <Route exact path='/signup' component={SignUpPage} />
      }
      <Route exact path='/confirmUser' component={ConfirmationAccountPage} />
      {yn(process.env.RAZZLE_ENABLE_URA_PASSWORD_VERIFICATION) &&  <Route exact path='/profile/create-ura-password' component={CreateUraPasswordPage} />}
      </Suspense>
    </Switch>
  </CookiesProvider>
)

export default withCookies(App)
